export const fragmentShader = `
uniform vec3 color;
uniform sampler2D pointTexture;
uniform sampler2D pointTexture2;
uniform float lerpPercent;
uniform float time;

varying vec3 vColor;
varying float distToCamera;
varying float isVisible;
varying float renderMode;
varying float useTexture;


void main() {
	if(renderMode <= 0.1){
		float distMult = 1.0-(5.0/distToCamera);
		float opacity = min(time / 2.0, 1.0) * (distMult) * isVisible;
		gl_FragColor = vec4( color * vColor, opacity );
		gl_FragColor = gl_FragColor * texture2D( pointTexture, gl_PointCoord );
	}
	if(renderMode >= 0.9 && renderMode < 2.0){
		float distMult = 1.0-(5.0/distToCamera);
		float opacity = (distMult) * isVisible;
		
		gl_FragColor = vec4( color * vColor, opacity * isVisible + 0.1 );
		
		if(useTexture == 0.0){
			gl_FragColor = gl_FragColor * texture2D( pointTexture, gl_PointCoord );
		}
		if(useTexture >= 0.9){
			gl_FragColor = gl_FragColor * texture2D( pointTexture2, gl_PointCoord );
		}
	}
	if(renderMode >= 1.9){
		float distMult = 1.0-(40.0/distToCamera);
		float opacity = (distMult) * isVisible;
		gl_FragColor = vec4( (1.0,1.0,1.0) * vColor, opacity * isVisible * 0.05 );
		gl_FragColor = gl_FragColor * 1.0 * texture2D( pointTexture2, gl_PointCoord );
	}

}
`